import React from "react"
import CurrencyFormat from "react-currency-format"

export default ({ value, currency = "CHF", showAsteriks = false }) => (
  <span>
    <CurrencyFormat
      displayType="text"
      value={value}
      thousandSeparator={","}
      decimalSeparator="."
      fixedDecimalScale
      decimalScale={2}
    />{" "}
    {currency} {showAsteriks && "*"}
  </span>
)
